import { useEffect, useRef } from 'react'
import { isReady } from '../utils/helperFunctions'

export function useUpdateEffect(
  callback: () => void,
  deps: unknown[] = []
): void {
  const didMount = useRef(false)
  useEffect(() => {
    if (didMount.current) {
      callback()
    } else if (deps.every(isReady)) {
      didMount.current = true
    }
  }, deps)
}
